/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_OccasionInputs */

const de__field_occasion = /** @type {(inputs: _Field_OccasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

/**

* @param {_Field_OccasionInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_occasion = /** @type {((inputs?: _Field_OccasionInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_OccasionInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_occasion(inputs)
});